module.exports = __webpack_public_path__ + "static/mini-bites-banner-ecdc1d253642cffb83ab2a7e5169d44c.jpg";